import { createFileRoute } from "@tanstack/react-router";
import type { FoodSensorySessionId } from "@brewbase/db/types";
import { PreviewTablet } from "@/external/tasting/PreviewTablet";
import { parsePreviewStart } from "@/external/tasting/preview-reducer";
import { signalPreviewReady } from "@/external/tasting/preview-room";

/** A tasting's preview tablet, framed by the editor's preview dialog, opened on the screen `at` names. */
export const Route = createFileRoute("/stage/preview/$tasting_id")({
  component: RouteComponent,
  parseParams: (params) => ({
    tasting_id: parseInt(params.tasting_id, 10),
  }),
  validateSearch: (search: Record<string, unknown>): { at?: string; room?: string } => ({
    at: typeof search.at === "string" ? search.at : undefined,
    room: typeof search.room === "string" ? search.room : undefined,
  }),
});

function RouteComponent() {
  const { tasting_id } = Route.useParams();
  const { at, room } = Route.useSearch();
  return (
    <>
      <PreviewTablet
        tastingId={tasting_id as FoodSensorySessionId}
        start={parsePreviewStart(at)}
        room={room ?? "tasting-preview"}
      />
      <span hidden ref={signalPreviewReady} />
    </>
  );
}
